"use client";

import React from "react";
import { FeedbackModal } from "./FeedbackModal";
import { useAppStore } from "@/store/useAppStore";

export const EmailConfimationModal = () => {
  const { setIsModalOpen, setActiveModal } = useAppStore();
  const handleSuccessModalClose = () => {
    setIsModalOpen(false);
    setActiveModal(null);
  };
  return (
    <FeedbackModal type="info" handleContinue={handleSuccessModalClose}>
      <div className="text-6xl mb-4">📧</div>
      <h2 className="text-2xl font-bold text-white mb-4">Check Your Email!</h2>
      <p className="text-gray-200 mb-6 leading-relaxed">
        We've sent you a confirmation link. Please check your email and click
        the link to activate your account.
      </p>
      <div className="text-sm text-gray-300 bg-blue-500/20 rounded-lg p-3 border border-blue-500/30">
        💡 Don't forget to check your spam folder!
      </div>
    </FeedbackModal>
  );
};
